import type { SVGComponentProps } from 'BreetHelpers';

export const AddRecipientIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='83'
		height='83'
		viewBox='0 0 83 83'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<g clipPath='url(#clip0_4910_112275)'>
			<path
				d='M73.5082 74.5098C60.9608 84.7526 21.782 84.7526 9.49062 74.5098C-3.05683 64.267 -1.7765 20.479 9.49062 8.95584C20.7577 -2.56731 62.2411 -2.56731 73.5082 8.95584C84.7753 20.479 86.0557 64.2671 73.5082 74.5098Z'
				fill='#8DC640'
			/>
			<g opacity='0.2'>
				<path
					d='M41.7562 56.5854C30.4891 65.5479 17.9416 70.1571 6.16246 70.4131C-2.544 55.5611 -0.751434 19.4552 9.49139 8.9564C18.7099 -0.518151 47.6458 -2.31072 64.2905 3.57887C68.3875 20.4795 59.9372 41.9893 41.7562 56.5854Z'
					fill='white'
				/>
			</g>
			<path
				d='M65.8266 41.2213C65.8266 43.782 63.778 45.8306 61.2174 45.8306H45.8532V61.1947C45.8532 63.7554 43.8046 65.804 41.244 65.804C38.6833 65.804 36.6347 63.7554 36.6347 61.1947V45.8306H21.2704C18.7097 45.8306 16.6611 43.782 16.6611 41.2213C16.6611 38.6607 18.7097 36.6121 21.2704 36.6121H36.6345V21.2479C36.6345 18.6873 38.6831 16.6387 41.2438 16.6387C43.8045 16.6387 45.8531 18.6873 45.8531 21.2479V36.6121H61.2172C63.778 36.6121 65.8266 38.6605 65.8266 41.2213Z'
				fill='white'
			/>
		</g>
		<defs>
			<clipPath id='clip0_4910_112275'>
				<rect
					width='82'
					height='82'
					fill='white'
					transform='translate(0.5 0.192383)'
				/>
			</clipPath>
		</defs>
	</svg>
);
